import React, { useEffect, useState } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png'
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

export default function Footer() {
  const [categories, setCategories] = useState([]);
  const [contact, setContact] = useState({});

  useEffect(() => {
    loadCategories();
    loadContact();
  }, []);

  const loadCategories = () => {
    fetch(`${baseURL}/categoriasGet.php`, { method: 'GET' })
      .then((res) => res.json())
      .then((data) => {
        // Nueva estructura: data.categorias = [{ idCategoria, categoria, slug, activa, createdAt, subcategorias: [...] }]
        if (data?.success && Array.isArray(data?.categorias)) {
          setCategories(data.categorias.slice(0, 3));
        } else {
          // Fallback por si en algún momento cambiaste la estructura
          setCategories([]);
        }
      })
      .catch((err) => console.error('Error loading categories:', err));
  };

  const loadContact = () => {
    fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.contactos && data.contactos.length > 0) {
          setContact(data.contactos[0]);
        } else {
          setContact(data.contacto?.reverse?.()[0] || {});
        }
      })
      .catch((err) => console.error('Error loading contact:', err));
  };

  return (
    <div className='FooterContain'>
      <div className='footerText'>
        <Anchor to='' target="_blank">
          <img src={logo} alt="logo" />
        </Anchor>
        <h2>{contact.nombre}</h2>
        <div className='socials'>
          <Anchor to={contact.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>
          <Anchor to={`https://wa.me/57${contact.telefono}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>
          <Anchor to={contact.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>
        </div>
      </div>

      <div className='footerText'>
        <h3>Contacto</h3>
        <Anchor to={`mailto:${contact.email}`} target="_blank">{contact.email}</Anchor>
        <Anchor to={`tel:+57${contact.telefono}`} target="_blank">{contact.telefono}</Anchor>
        <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contact.direccion || '')}`} target="_blank">
          {contact.direccion}
        </Anchor>
      </div>

      <div className='footerText'>
        <h3>Productos</h3>
        {categories.map((cat) => (
          <Anchor key={cat.idCategoria} to=''>
            {String(cat.categoria).slice(0, 33)}
          </Anchor>
        ))}
      </div>

      <div className='footerText'>
        <h3>Acceso</h3>
        <Anchor to={`/dashboard`} className='btnAnch'>
          <FontAwesomeIcon icon={faUser} /> Dashboard
        </Anchor>
      </div>
    </div>
  );
}
